export default {
  'Your win': 'Dein Gewinn',
  'Select skins that you want to take': 'Wähle die Skins aus, die du gerne haben möchtest',
  'By price': 'Nach Preis',
  '(Autotrade will receive after 10 minutes)':
    '(Der automatische Handel wird nach zehn Minuten abgewickelt)',
  ACCEPT: 'Bestätigen',
  'SELECT ALL': 'SELECT ALL',
};
